import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import { AppFrame, TopBar, BottomNav } from "@/components/Shell";
import { Search as SearchIcon } from "lucide-react";

export default function SearchPage() {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [all, setAll] = useState([]);

  useEffect(() => {
    (async () => {
      const p = await api.get("/products", { params: { limit: 100 } });
      setAll(p.data);
      setResults(p.data);
    })();
  }, []);

  useEffect(() => {
    const t = setTimeout(async () => {
      if (!q.trim()) { setResults(all); return; }
      setLoading(true);
      const p = await api.get("/products", { params: { q } });
      setResults(p.data);
      setLoading(false);
    }, 250);
    return () => clearTimeout(t);
  }, [q, all]);

  return (
    <AppFrame>
      <TopBar title="Search" subtitle="Discover" />
      <div className="px-5 mt-4">
        <div className="flex items-center gap-2 border border-black/10 rounded-full px-4 h-12 bg-white">
          <SearchIcon size={18} strokeWidth={1.5} className="text-neutral-500" />
          <input
            data-testid="search-input"
            autoFocus
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Search products, brands, categories..."
            className="flex-1 outline-none text-sm bg-transparent"
          />
          {q && (
            <button data-testid="search-clear" onClick={() => setQ("")} className="text-xs text-neutral-500">Clear</button>
          )}
        </div>
        <div className="mt-6">
          {loading ? (
            <div className="text-xs text-neutral-500">Searching…</div>
          ) : results.length === 0 ? (
            <div className="rounded-2xl bg-zinc-50 border border-black/5 py-14 text-center">
              <div className="font-display text-lg">No matches</div>
              <p className="text-xs text-neutral-500 mt-1">Try a different keyword.</p>
            </div>
          ) : (
            <div className="grid grid-cols-2 gap-3">
              {results.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
            </div>
          )}
        </div>
      </div>
      <BottomNav />
    </AppFrame>
  );
}
